/**
 * True when `value` parses as an absolute http(s) URL.
 * Used before window.open for stamped store links (plan JSON is not server-validated).
 */
export const isSafeHttpUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value.trim());
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};
